<template>
    <div class="has-text-centered lb-media-link">
        <a :href="url" target="_blank" class="button is-link is-fullwidth">
            <!--<span class="icon">
                <i class="fas fa-link" />
            </span>-->
            <span>{{ $t('Object.url_more_info') }}</span>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            default: undefined,
        },
    },
};
</script>

<style></style>
